import conf from "@/config";

// URL slike obroka iz narudžbe (order.meals.image); null ako obrok nema sliku.
// restaurant_id uzimamo sa slike jer klonirani obroci koriste galeriju originalnog restorana.
export function orderMealImageUrl(order, size = "medium") {
  const image = order?.meals?.image;
  if (!image?.name) return null;
  const restaurantId = image.restaurant_id || order.restaurant_id;
  return [conf.apiUrlBase, "gallery", restaurantId, size, image.name].join("/");
}
